import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"
import FacebookPixel from 'react-facebook-pixel';

// Initialize Meta Pixel
const options = {
    autoConfig: false, // Enables automatic event tracking (optional)
    debug: true,      // Logs debug info to console for troubleshooting
};
FacebookPixel.init(process.env.REACT_APP_META_PIXEL_ID, options); // Replace with your Pixel ID
FacebookPixel.pageView(); // Track initial page view

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
